import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PreSimulationComponent } from './components/pre-simulation/pre-simulation.component';
import { CreateCustomerModalComponent } from './components/pre-simulation/create-customer-modal/create-customer-modal.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { FreeDraggingDirective } from './directives/free-dragging.directive';
import { FreeDraggingHandleDirective } from './directives/free-dragging-handle.directive';
import { ErrorMessageDirective } from './directives/error-message.directive';

@NgModule({
  declarations: [
    PreSimulationComponent, 
    CreateCustomerModalComponent,
    ErrorMessageComponent,
    FreeDraggingDirective,
    FreeDraggingHandleDirective,
    ErrorMessageDirective
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule],
  exports: [
    PreSimulationComponent, 
    CreateCustomerModalComponent,
    ErrorMessageComponent,
    FreeDraggingDirective,
    FreeDraggingHandleDirective,
    ErrorMessageDirective
  ]
})
export class SharedModule {}
